
import AppNotifications from './components/AppNotifications'

export default {
  install(Vue) {
    Vue.component('app-notifications', AppNotifications)
  }
}
